import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GetDemographics {
  loading: boolean;
  data: [];
  status: number;
  error: null | string;
}

export const initialState: GetDemographics = {
  loading: false,
  data: [],
  status: 0,
  error: null,
};

const demographicsListSlice = createSlice({
  name: "demographics",
  initialState,
  reducers: {
    reset: () => initialState,
    getDemographicsListRequest(state: GetDemographics) {
      state.loading = true;
    },
    getDemographicsListSuccess(
      state: GetDemographics,
      action: PayloadAction<{ data: any; status: number }>,
    ) {
      state.loading = false;
      state.data = action.payload.data;
      state.status = action.payload.status;
    },
    getDemographicsListFailure(
      state: GetDemographics,
      action: PayloadAction<{ error: any }>,
    ) {
      state.loading = false;
      state.error = action.payload.error;
    },
  },
});

export const demographicsListAction = demographicsListSlice.actions;
export const demographicsReducer = demographicsListSlice.reducer;

export default demographicsReducer;
